// Upload Temp Audience logo for DSR
export const UPLOAD_TEMP_AUDIENCE_LOGO_REQUEST = 'upload_temp_audience_logo_request';
export const UPLOAD_TEMP_AUDIENCE_LOGO_SUCCESS = 'upload_temp_audience_logo_success';
export const UPLOAD_TEMP_AUDIENCE_LOGO_FAILURE = 'upload_temp_audience_logo_failure';